import { ICompany } from '@company/company.structures';
import { OpenWorkbookAs } from '@utils';
import { ISnackParams } from '@interfaces';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBarConfig } from '@angular/material';

export class Etl {
    id: number = null;
    name: string = null;
    path_job: string = null;
    company: number | ICompany = null;
    first_log: Date = null;
    last_log: Date = null;
    display_username: string = null;
    success: Boolean = false;
    status: string = null;
    message: string = null;
    job_id: string = null;
    log_text: string = null;
}

export class Role {
    id: number = null;
    name = '';
    code = '';
    is_deletable = false;
}

export class Error {
    title = '';
    message = '';
}

export class ApiResponse {
    count: Number = 0;
    next: String = '';
    previous: String = '';
    results: [] = [];
}

export class Parameter {
    id: number = null;
    module_name: string = null;
    data: object = null;
}

export class Company {
    id: number = null;
    name: string = null;
    slug: string = null;
    color: string = null;
    domain: string = null;
    image_url: string = null;
    created_at: Date = null;
    updated_at: Date = null;
    tableau_id: string = null;
    workbooks: Workbook[] = [];
}

export class Workbook {
    id: number = null;
    name: string = null;
    content_url: string = null;
    size: number = null;
    created_at: Date = null;
    updated_at: Date = null;
    tableau_id: string = null;
    webpage_url: string = null;
    show_tabs: Boolean = false;
    thumbnail: string = null;
    company: number | Company = null;
    views: View[] = [];
    open_as: String = OpenWorkbookAs.Report;
}

export class View {
    id: number = null;
    name: string = null;
    content_url: string = null;
    created_at: Date = null;
    updated_at: Date = null;
    tableau_id: string = null;
    thumbnail: string = null;
    workbook: number | Workbook = null;
    default_view: Boolean = false;
}

export class User {
    id: number = null;
    password: string = null;
    last_login: Date = null;
    is_superuser: Boolean = false;
    username: string = null;
    first_name: string = null;
    last_name: string = null;
    is_staff: Boolean = false;
    is_active: Boolean = false;
    date_joined: Boolean = null;
    email: string = null;
    updated_at: Boolean = null;
    role: number | Role = null;

    tableau_id: string = null;
    tableau_license_type: string = null;
    tableau_pass: string = null;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}

export class SnackBar implements ISnackParams {
    message: string;
    title = '';
    config: MatSnackBarConfig = {
        verticalPosition: 'top' as MatSnackBarVerticalPosition,
        horizontalPosition: 'right' as MatSnackBarHorizontalPosition,
        duration: 4000,
    };

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
